export default __webpack_public_path__ + "static/media/繁育师勋章.2c3fcdc2.png";